import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { zodResolver } from "@hookform/resolvers/zod";
import { FormSwitchInput } from "../../../../../../common/components/masked_inputs/react_forms/form_switch_input";
import { useEffect } from "react";
import { PesquisaSatisfacaoLista } from "../../../../domain/models/pesquisa_satisfacao_lista";
import { PesquisaSatisfacaoForm, PesquisaSatisfacaoSchema } from "../../../schemas/CadastroPesquisa_lista/pesquisa_satisfacao";

import DefaultFormInput from "../../../../../../common/components/default_form_input";
import PrimaryButton from "../../../../../../components/global/PrimaryButton";

/**
 * PesquisaSatisfacaoModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  selectedPesquisaSatisfacao: PesquisaSatisfacaoLista | null;
  onClose: () => void;
  onSubmit: (form: PesquisaSatisfacaoForm) => Promise<void>;
  onOpenChangeHistory: () => void;
};

export const PesquisaSatisfacaoModal = ({
  open,
  saving,
  loading,
  selectedPesquisaSatisfacao,
  onClose,
  onSubmit,
  onOpenChangeHistory
}: Props) => {

  const hookForm = useForm<PesquisaSatisfacaoForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(PesquisaSatisfacaoSchema),
  });

  useEffect(() => {
    if (open) {
      if (selectedPesquisaSatisfacao) {
        hookForm.setValue('status', selectedPesquisaSatisfacao.status);
        hookForm.setValue('codigo', selectedPesquisaSatisfacao.codigo ?? '');
        hookForm.setValue('descricao', selectedPesquisaSatisfacao.descricao ?? '');
      } else {
        hookForm.reset({ status: 1 });
      }
    }
  }, [
    open,
    hookForm,
    selectedPesquisaSatisfacao,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title="Pesquisa de Satisfação"
      leftButtonSlot={
        selectedPesquisaSatisfacao && (
          <PrimaryButton
            buttonColor="yellow"
            onClick={() => onOpenChangeHistory()}>
            <span className="text-xs">
              Historico de alterações
            </span>
          </PrimaryButton>
        )
      }
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <div className="w-full flex flex-col gap-2 my-2">
        <FormSwitchInput
          name="status"
          reactHookForm={hookForm}
        />

        <DefaultFormInput
          name='codigo'
          label='Código da Pesquisa'
          required={true}
          reactHookForm={hookForm}
        />

        <DefaultFormInput
          name='descricao'
          label='Descrição do Pesquisa'
          required={true}
          multiline={true}
          rows={7}
          reactHookForm={hookForm}
        />
      </div>
    </BaseFormControlledModal >
  );
}